import { Storage } from "@ionic/storage";

import { Injectable } from '@angular/core';

@Injectable()
export class AppStorage {

    private static INSTANCE = new Storage({
        name: 'phicube_db',
        driverOrder: ['indexeddb', 'sqlite', 'websql']
    })

    // setando uma seção e passando o tipo de usuário
    static async set(key: string, value: any) {
        return await AppStorage.INSTANCE.set(key, value);
    }

    static async get(key: string) {
        return await AppStorage.INSTANCE.get(key);
    }

    // Quando deslogar deve remova do storage
    static remove(key: string) {
        AppStorage.INSTANCE.remove(key);
    }

    static removeListKeys(keys: Array<string>) {
        keys.forEach((value, index) => {
            this.remove(value)
        })
    }

    static exist(key: string) {
        return new Promise((resolve, reject) => {
            this.get(key).then(res => {
                console.log('resultado >>> ', res);
                if(res) {
                    resolve(true)
                } else {
                    reject(false)
                }
            });
        })
    }
}